/**
 * All the new routes that were created. Any additional routes added should be added
 * here
 */

export const VERSION = '/v2';
export const BOTS = `${VERSION}/bots`;
export const STORIES = `${BOTS}/:botId/stories`;
export const SUBSTORIES = `${STORIES}/:storyId/substories`;
export const CONNECTION = `${STORIES}/:storyId/:subStoryId/connections/:sourceType/:sourceId/:destType/:destId`;
export const CONNECTION_USER_SAYS = `${CONNECTION}/user-says`;
export const CONNECTION_ENTITIES = `${CONNECTION}/entities`;
export const NODES = `${SUBSTORIES}/:subStoryId/nodes`;
export const NODE = `${NODES}/:nodeId`;
export const NEW_NODE = `${NODES}/:nodeId`;
export const NEW_AISS_NODE = `${SUBSTORIES}/:subStoryId/aiss/:nodeId`;
export const AISS_CODE_NODE_EDITOR = `${NEW_AISS_NODE}/output/editor`;
export const NEW_CODE_NODE = `${SUBSTORIES}/:subStoryId/code/:nodeId`;
export const CODE_NODE_OUTPUT = `${NEW_CODE_NODE}/output`;
export const CODE_NODE_EDITOR = `${NEW_CODE_NODE}/output/editor`;
export const CODE_NODE_SETTINGS = `${NEW_CODE_NODE}/settings`;
export const DYNAMIC_NODE = `${SUBSTORIES}/:subStoryId/dynamic/:nodeId`;
export const DYNAMIC_NODE_BOT_SAYS = `${DYNAMIC_NODE}/bot-says`;
export const DYNAMIC_NODE_SETTINGS = `${DYNAMIC_NODE}/settings`;
export const NODE_USER_SAYS = `${NODE}/user-says`;
export const NODE_BOT_SAYS = `${NODE}/bot-says`;
export const NODE_CONNECTIONS = `${NODE}/connections`;
export const NODE_INTEGRATIONS = `${NODE}/integrations`;
export const NODE_INTEGRATIONS_EDITOR = `${NODE}/integrations/editor`;
export const NODE_SETTINGS = `${NODE}/settings`;

export const ALL_SMART_SKILLS = '/smart-skills';
export const AGENT_ESCALATION = `${BOTS}/:botId/agent-escalation/:clientId/:businessId`;
export const EDIT_TOOL = `${AGENT_ESCALATION}/:fqdn`;
export const EDIT_TOOL_PARAMS = `${EDIT_TOOL}/:value`;
export const AGENT_ESCALATION_ROUTE = (botId, clientId, businessId) =>
  `${BOTS}/${botId}/agent-escalation/${clientId}/${businessId}`;

export const SMALLTALK = `${BOTS}/:botId/smalltalk`;

/**
 * @deprecated These are V1 and should slowly be phased out
 */
export const V1_BOT_SAYS =
  '/bot/:botId/:storyId/:subStoryId/:nodeId/bot-responses';
export const V1_USER_SAYS =
  '/bot/:botId/:storyId/:subStoryId/:nodeId/independent-response';
export const V1_INTEGRATIONS =
  '/bot/:botId/:storyId/:subStoryId/:nodeId/partner-response';
